'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var p = require('prop-types');
var reactRouterDom = require('react-router-dom');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var name = "arm-router";
var version = "1.3.0";
var author = "Armundia Group";
var homepage = "http://www.armundia.com";
var license = "Armundia";
var main = "./dist/main/index.js";
var files = [
	"dist"
];
var devDependencies = {
	"arm-core-layouts": "0.1.13",
	"arm-gui": "3.1.2-beta.5",
	"arm-gulp-builders": "1.2.0",
	"arm-themes": "1.2.1-beta.1",
	"arm-visual-component": "^2.1.0",
	"babel-eslint": "^10.0.3",
	"babel-plugin-markdown": "^0.3.0",
	"eslint-plugin-import": "2.22.1",
	"eslint-plugin-react": "7.23.2",
	"immutability-helper": "^3.1.1",
	react: "16.13.1",
	"react-dom": "16.13.1",
	"react-markdown": "^5.0.3",
	"react-redux": "^7.2.3",
	redux: "^4.0.5",
	"redux-thunk": "^2.3.0"
};
var dependencies = {
	"prop-types": ">=15.7.2 <16.0.0-0",
	"react-router-dom": ">=5.2.0 <6.0.0-0"
};
var scripts = {
	watch: "gulp watch",
	build: "gulp npm",
	republish: "gulp npm && npm publish",
	beta: "npm version prerelease --preid=beta && gulp npm && npm publish --tag beta",
	patch: "npm version patch && gulp npm && npm publish",
	minor: "npm version minor && gulp npm && npm publish",
	major: "npm version major && gulp npm && npm publish"
};
var publishConfig = {
	registry: "https://nexus.armundia.com/repository/npm-releases"
};
var pckg = {
	name: name,
	version: version,
	author: author,
	homepage: homepage,
	license: license,
	main: main,
	files: files,
	devDependencies: devDependencies,
	dependencies: dependencies,
	scripts: scripts,
	publishConfig: publishConfig
};

/**
 * @author [a.seravalli](http://gitea.armundia.com/a.seravalli)
 * 
 * Menu flex-container
 *  
 * @param {object} props properties of Menu
 * @param {string} [props.id] container id
 * @param {string} [props.className] container selector
 * @param {('stretch'|'center'|'flex-start'|'flex-end'|'baseline'|'initial'|'inherit')} [props.alignItems='center'] css-flexbox property align-items (es: center, flex-end, flex-start ecc.)
 * @param {string|number} [props.height] container height (if vertical = true default: '100vh')
 * @param {string|number} [props.width] container width (se vertical = true default: '100vh')
 * @param {boolean} [props.vertical] if true, displays the bar in a column
 * @param {boolean} [props.reverse] if true, reverses the arrangement of the elements
 * @param {node} props.children React children
 * @return {JSX.Element}
 * 
 * @example
 * 
 * ```jsx
 * const alignItems = 'flex-end',
 *       height = 'calc(100vh - 70px)',
 *       width = '150px',
 *       vertical = true,
 *       id = 'id-menu',
 *       className = 'selectors';
 * <Menu alignItems={alignItems} height={position} width={width} vertical={vertical} id={id} className={className} >
 *     ...
 *     <MenuLink/>
 *     <MenuDrop>
 *         <MenuLink/>
 *         ...
 *     </MenuDrop>
 *     ...
 * </Menu>
 * ```
 */

function Menu(props) {
  console.log('[Menu.jsx]: render');
  var _props$alignItems = props.alignItems,
      alignItems = _props$alignItems === void 0 ? 'center' : _props$alignItems,
      _props$height = props.height,
      height = _props$height === void 0 ? '100vh' : _props$height,
      _props$width = props.width,
      width = _props$width === void 0 ? '100%' : _props$width,
      _props$className = props.className,
      className = _props$className === void 0 ? '' : _props$className,
      id = props.id,
      vertical = props.vertical,
      reverse = props.reverse,
      children = props.children;
  var barStyle = {
    display: 'flex',
    alignItems: alignItems,
    height: height,
    width: width
  };

  if (vertical) {
    barStyle.flexDirection = 'column';
    if (!props.width) delete barStyle.width;
  } else {
    barStyle.flexDirection = 'row';
    if (!props.height) delete barStyle.height;
  }

  if (reverse) barStyle.flexDirection += '-reverse';
  return /*#__PURE__*/React.createElement("div", {
    id: id,
    style: barStyle,
    className: "arm-menu ".concat(className).trimEnd()
  }, children);
}
Menu.propTypes = {
  alignItems: p.string,
  height: p.string,
  width: p.string,
  vertical: p.bool,
  reverse: p.bool,
  id: p.string,
  className: p.string,
  children: p.node
};

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

/**
 * @callback _Link
 * 
 * @param {object} props properties of Link
 * @param {string} [props.id] anchor id
 * @param {string} [props.className] anchor selector
 * @param {string} [props.label] anchor content
 * @param {node} [props.children] anchor content as React children
 * @param {string} [props.icon] icon selector (glyph)
 * @param {string} [props.url] application path
 * @param {(e: Event) => any} [props.onClick] onclick event
 * @param {windowOpenOpt} [props.windowOpenOpt] Window.open() options
 * @return {JSX.Element}
 */

/**
 * @typedef {object} windowOpenOpt
 * @prop {('_blank'|'_parent'|'_self'|'_top'|'nameOfWindow')} [target='_blank'] specifies the target attribute or the name of the window
 * @prop {string} [features] A comma-separated list of items, no whitespaces {@link https://www.w3schools.com/jsref/met_win_open.asp}
 * @prop {boolean} [replace] specifies whether the URL creates a new entry or replaces the current entry in the history list
 * @prop {(window: Window) => any} [onOpen] the new window when window.open is executed
 */
exports.typedefs = {};

/**
 * @callback _MenuLink
 * Uses `NavLink` from `react-router-dom` with Armundia styles.
 * See `NavLink` for properties {@link https://reacttraining.com/react-router/web/api/NavLink}
 * 
 * @param {NavLinkProps | MenuLinkProps} props
 * @returns {JSX.Element}
 */

/**
 * @typedef {object} NavLinkProps properties of NavLink used for MenuLink
 * @prop {string} [to] href path
 * @prop {React.CSSProperties} [activeStyle] inline style when link is active
 * @prop {boolean} [exact] the selection is applied when the location is strictly equals to `to` property
 * @prop {boolean} [strict] {@link https://reacttraining.com/react-router/core/api/Route/strict-bool}
 * @prop {(match: boolean, location: string) => boolean} [isActive] function that add an additional logic for selection
 * @prop {(e: Event) =>  any} [onClick] callback executed when click link
 */

/**
 * @typedef {object} MenuLinkProps properties of MenuLink
 * @prop {string|number} [id] div id
 * @prop {boolean} [visible=true] show/hide element
 * @prop {string} [className] div selector
 * @prop {string} [linkClassName] link selector
 * @prop {string} [activeClassName] selector when link is active
 * @prop {boolean} [disabled=false] disable link
 * @prop {(string|externalLinkOpt|windowOpenOpt)} [externalLink] href to external path or externalLink options
 * @prop {string} label anchor label
 * @prop {Node} children anchor label
 */

/**
 * @typedef {object} externalLinkOpt externalLink options
 * @prop {string} url specifies the URL of the page to open
 * @prop {string} [icon='fas fa-share-square'] icon of externalLink
 */

exports.typedefs = {};

var classNamePrefix = 'arm-router-link';
/**
 * Base Anchor component
 * 
 * @type {_Link}
 */

function Link(props) {
  console.debug('[Link]: render');
  var id = props.id,
      className = props.className,
      label = props.label,
      icon = props.icon,
      url = props.url,
      onClick = props.onClick,
      windowOpenOpt = props.windowOpenOpt,
      children = props.children;
  var aProps = {
    id: id,
    onClick: onClick,
    className: "".concat(classNamePrefix, " ").concat(className).trimEnd(),
    href: "#".concat(url),
    target: '_blank'
  };

  if (windowOpenOpt) {
    delete aProps.href;
    delete aProps.target;

    aProps.onClick = function () {
      var _windowOpenOpt$target = windowOpenOpt.target,
          target = _windowOpenOpt$target === void 0 ? '_blank' : _windowOpenOpt$target,
          features = windowOpenOpt.features,
          replace = windowOpenOpt.replace,
          onOpen = windowOpenOpt.onOpen;
      var newWindow = window.open("#".concat(url), target, features, replace);
      if (onOpen) onOpen(newWindow);
    };
  }

  return /*#__PURE__*/React__default['default'].createElement("a", aProps, label || children, icon && /*#__PURE__*/React__default['default'].createElement("i", {
    className: "".concat(classNamePrefix, "-icon ").concat(icon)
  }));
}
Link.propTypes = {
  id: p.string,
  className: p.string,
  label: p.string,
  icon: p.string,
  url: p.string,
  windowOpenOpt: p.shape({
    target: p.string,
    features: p.string,
    replace: p.bool,
    onOpen: p.func
  }),
  children: p.node
};

var classNamePrefix$1 = 'arm-router-menu-link';
var linkClass = 'arm-router-menu-nav-link';
var activeClass = 'arm-router-menu-nav-link-selected';
var disabledLinkClass = classNamePrefix$1 + '-disabled-link';

var addExternalLink = function addExternalLink(externalLink) {
  if (externalLink) {
    if (typeof externalLink === 'string') {
      return /*#__PURE__*/React.createElement(Link, {
        url: externalLink,
        className: "".concat(classNamePrefix$1, "-ext-link"),
        icon: "fas fa-share-square"
      });
    } else if (_typeof(externalLink) === 'object' && externalLink.url) {
      var externalLinkOpt = _objectSpread2({
        target: '_blank',
        icon: 'fas fa-share-square',
        features: undefined,
        replace: undefined,
        onOpen: undefined
      }, externalLink);

      var linkProps = {
        className: "".concat(classNamePrefix$1, "-ext-link"),
        url: externalLinkOpt.url,
        icon: externalLinkOpt.icon,
        windowOpenOpt: {
          target: externalLinkOpt.target,
          features: externalLinkOpt.features,
          replace: externalLinkOpt.replace,
          onOpen: externalLinkOpt.onOpen
        }
      };
      return /*#__PURE__*/React.createElement(Link, linkProps);
    }
  }

  return null;
};
/**
 * @author [a.seravalli](http://gitea.armundia.com/a.seravalli)
 * 
 * @type {_MenuLink}
 * 
 * @example
 * 
 * ```jsx
 * const id = 'id-menulink',
 *       className = 'selectors';
 *       to = '/path/to/go',
 *       activeStyle = {color: 'red', backgroundColor: 'grey'}, //only if you want change default behaviour
 *       strict = 'true',
 *       onClick = () => { alert('The path is changed') }
 * <MenuLink id={id} className={className} to={to} activeStyle={activeStyle} strict={strict} onClick={onClick}>
 *     <LabelComponent/>
 * </MenuLink>
 * ```
 */


function MenuLink(props) {
  console.debug('[MenuLink.jsx]: render');
  var _props$visible = props.visible,
      visible = _props$visible === void 0 ? true : _props$visible,
      _props$className = props.className,
      className = _props$className === void 0 ? '' : _props$className,
      _props$linkClassName = props.linkClassName,
      linkClassName = _props$linkClassName === void 0 ? '' : _props$linkClassName,
      _props$activeClassNam = props.activeClassName,
      activeClassName = _props$activeClassNam === void 0 ? '' : _props$activeClassNam,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      id = props.id,
      label = props.label,
      children = props.children,
      externalLink = props.externalLink,
      activeStyle = props.activeStyle,
      exact = props.exact,
      strict = props.strict,
      isActive = props.isActive,
      onClick = props.onClick;
  if (!visible) return null;
  var classNameComponent = classNamePrefix$1;
  var to = props.to || '#';

  if (disabled) {
    classNameComponent += ' ' + disabledLinkClass;
    to = '#';
  }

  return /*#__PURE__*/React.createElement("div", {
    id: id,
    className: "".concat(classNameComponent, " ").concat(className).trimEnd()
  }, /*#__PURE__*/React.createElement(reactRouterDom.NavLink, {
    to: to,
    className: "".concat(linkClass, " ").concat(linkClassName).trimEnd(),
    activeClassName: to !== '#' && "".concat(activeClass, " ").concat(activeClassName).trimEnd(),
    activeStyle: to !== '#' && activeStyle,
    exact: exact,
    strict: strict,
    isActive: isActive,
    onClick: onClick
  }, label || children), addExternalLink(externalLink));
}
MenuLink.propTypes = {
  visible: p.bool,
  id: p.string,
  className: p.string,
  linkClassName: p.string,
  activeClassName: p.string,
  externalLink: p.oneOfType([p.string, p.shape({
    url: p.string.isRequired,
    target: p.string,
    features: p.string,
    replace: p.bool,
    icon: p.string,
    onOpen: p.func
  })]),
  label: p.string,
  children: p.node,
  to: p.string,
  activeStyle: p.object,
  exact: p.bool,
  strict: p.bool,
  isActive: p.func,
  onClick: p.func,
  disabled: p.bool
};

/**
 * @callback _MenuDrop
 * Creates a dropdown menu with MenuLink/MenuDrop.
 * 
 * @param {MenuDropProps} props
 * @returns {JSX.Element}
 */

/**
 * @typedef {object} MenuDropProps properties of MenuDrop
 * @prop {string|number} [id] div id
 * @prop {boolean} [visible=true] show/hide element
 * @prop {string} [className] div selector
 * @prop {string} label anchor label
 * @prop {string} [icon='fas fa-chevron'] css icon selector prefix
 * @prop {boolean} [hover=false] open drop on mouse hover
 * @prop {('down'|'up'|'left'|'right')} [position='down'] dropdown position
 * @prop {_MenuDrop|_MenuLink|Array<_MenuDrop|_MenuLink>} children one or more MenuDrop/MenuLink
 */

exports.typedefs = {};

Map.prototype.includes = function (pathname) {
  var hasPathname = false;
  this.forEach(function (value, key) {
    if (pathname.includes(key)) hasPathname = true;
  });
  return hasPathname;
};

var classNamePrefix$2 = 'arm-menu-drop';
var menudropId = 0;

var MenuDrop = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(MenuDrop, _React$PureComponent);

  var _super = _createSuper(MenuDrop);

  function MenuDrop(props) {
    var _this;

    _classCallCheck(this, MenuDrop);

    _this = _super.call(this, props);

    _this.componentLog = function (type) {
      return console.debug('[MenuDrop.jsx]: ' + type);
    };

    _this.state = {
      paths: new Map(),
      show: false,
      selected: null,
      on: false,
      //variabile usata per il selezionamento. Property messa perche' se tra il padre e l'ultimo MenuDrop ci sono altri MenuDrop, questi devono apparire selezionati (per capire in quale tendina si trova il figlio selezionato)
      id: props.id || "".concat(classNamePrefix$2, "-").concat(menudropId++)
    };
    _this.onBlur = _this.onBlur.bind(_assertThisInitialized(_this));
    _this.onChangeSelected = _this.onChangeSelected.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(MenuDrop, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.componentLog('componentDidMount');
      var _this$props = this.props,
          hover = _this$props.hover,
          children = _this$props.children; //Creo una mappa path => path dei vari MenuLink

      var paths = this.state.paths;
      React.Children.forEach(children, function (child) {
        return child && child.props && child.props.to ? paths.set(child.props.to, child.props.to) : null;
      });
      this.setState({
        paths: paths
      });
      if (!hover) window.addEventListener('click', this.onBlur);
      this.updateComponent();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.componentLog('componentWillUnmount');
      if (!this.props.hover) window.removeEventListener('click', this.onBlur);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      this.componentLog('componentDidUpdate');
      this.updateComponent(prevProps);
    }
  }, {
    key: "updateComponent",
    value: function updateComponent(prevProps) {
      var pathname = this.props.location.pathname;
      var paths = this.state.paths;
      var selected = this.props.selected !== undefined ? this.props.selected : //MenuDrop figlio di un MenuDrop
      this.state.selected; //MenuDrop padre

      if (prevProps) {
        //Chiude il drop quando si ha un cambio di path (caso di apertura con click)
        if (prevProps.location.pathname !== pathname && !this.props.hover && this.state.show) this.setState({
          show: false
        }); //Tutte le volte che cambia di path, il componente viene resettato

        if (prevProps.location.pathname !== pathname && selected !== null) return this.onChangeSelected(null);
      } //Per evitare un loop infinito nel DidUpdate, confronto il selected (che contiene il path settato) con il pathname


      if (selected !== pathname && paths.includes(pathname)) this.onChangeSelected(pathname);
    }
    /**
     * Funzione per aggiornare lo stato del MenuDrop o dei MenuDrop, nel caso in cui il MenuDrop sia figlio di un MenuDrop
     * 
     * @param {*} selected path o null
     */

  }, {
    key: "onChangeSelected",
    value: function onChangeSelected(selected) {
      var updateState = {};
      updateState.on = !!selected; //MenuDrop deve apparire selezionato (in caso di path) o deselezionato (in caso di null)

      if (!!this.props.onChangeSelected) this.props.onChangeSelected(selected); //caso MenuDrop figlio di un MenuDrop
      else updateState.selected = selected; //caso MenuDrop padre

      this.setState(updateState);
    }
  }, {
    key: "onBlur",
    value: function onBlur(e) {
      return document.getElementById(this.state.id).contains(e.target) || this.setState({
        show: false
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      this.componentLog('render');
      var _this$props2 = this.props,
          _this$props2$visible = _this$props2.visible,
          visible = _this$props2$visible === void 0 ? true : _this$props2$visible,
          _this$props2$classNam = _this$props2.className,
          className = _this$props2$classNam === void 0 ? '' : _this$props2$classNam,
          _this$props2$position = _this$props2.position,
          position = _this$props2$position === void 0 ? 'down' : _this$props2$position,
          _this$props2$icon = _this$props2.icon,
          icon = _this$props2$icon === void 0 ? 'fas fa-chevron' : _this$props2$icon,
          hover = _this$props2.hover,
          label = _this$props2.label,
          children = _this$props2.children;
      var _this$state = this.state,
          on = _this$state.on,
          id = _this$state.id,
          show = _this$state.show;
      if (!visible) return null; //props interna per determinare il selezionamento ricorsivo fino al padre

      var selected = this.props.selected !== undefined ? this.props.selected : //MenuDrop figlio di un MenuDrop
      this.state.selected; //MenuDrop padre

      var onClick = function onClick() {
        return _this2.setState({
          show: !show
        });
      };

      var typeClassName = '';

      if (hover) {
        typeClassName = 'hoverable';
        onClick = null;
      } else if (show) {
        typeClassName = 'active';
      }

      var iconCls = "".concat(icon, "-").concat(position, " ").concat(position);
      var iconLeft = null;
      var iconRight = /*#__PURE__*/React.createElement("i", {
        className: iconCls
      });

      if (position === 'left') {
        iconLeft = /*#__PURE__*/React.createElement("i", {
          className: iconCls
        });
        iconRight = null;
      }

      return /*#__PURE__*/React.createElement("div", {
        id: id,
        className: "".concat(classNamePrefix$2, " ").concat(className, " ").concat(typeClassName).trimEnd()
      }, /*#__PURE__*/React.createElement("a", {
        className: "arm-menu-dropbtn ".concat(on ? 'arm-router-menu-nav-link-selected' : '').trimEnd(),
        onClick: onClick
      }, iconLeft, " ", label, " ", iconRight), /*#__PURE__*/React.createElement("div", {
        className: "".concat(classNamePrefix$2, "-content ").concat(position.toLowerCase()).trimEnd()
      }, React.Children.map(children, function (child) {
        if (child && child.type.toString() === MenuDropRouter.toString()) {
          //se sono dello stesso tipo (quindi il figlio è un MenuDrop)
          var childProperties = _extends({}, child.props); //Caso MenuDrop padre (this.props.selected === undefined) passo this.state.selected
          //Caso MenuDrop figlio di un MenuDrop (this.props.selected !== undefined) passo this.props.selected, che sarebbe il this.state.selected del padre


          childProperties.selected = selected;
          childProperties.onChangeSelected = _this2.onChangeSelected;
          child = /*#__PURE__*/React.createElement(child.type, childProperties);
        }

        return child;
      })));
    }
  }]);

  return MenuDrop;
}(React.PureComponent);
/**
 * @author [a.seravalli](http://gitea.armundia.com/a.seravalli)
 * 
 * @type {_MenuDrop}
 * 
 * @example
 * 
 * ```jsx
 * const hover = true,
 *       position = 'up',
 *       label = 'prova',
 *       id = 'id-menudrop',
 *       className = 'selectors';
 * <MenuDrop hover={hover} position={position} label={label} id={id} className={className} >
 *     ...
 *     <MenuLink/>
 *     <MenuDrop>
 *         <MenuLink/>
 *         ...
 *     </MenuDrop>
 *     ...
 * </MenuDrop>
 * ```
 */


var MenuDropRouter = function MenuDropRouter(props) {
  return /*#__PURE__*/React.createElement(MenuDrop, _extends({
    location: reactRouterDom.useLocation()
  }, props));
}; //aggancia il location di react-router-dom e necessario per riga 88


MenuDropRouter.propTypes = {
  visible: p.bool,
  hover: p.bool,
  position: function position(props, propName, componentName) {
    if (props[propName] === undefined) return null;
    var oneOf = ['down', 'up', 'left', 'right'];

    if (typeof props[propName] !== 'string' || !oneOf.find(function (e) {
      return e === props[propName].toLowerCase();
    })) {
      //se non e' una stringa o se non fa parte dell'array lancio errore
      return new Error('Invalid prop `' + propName + '` supplied to' + ' `' + componentName + '`. It needs to be one of this strings: [' + oneOf.toString() + '].');
    }
  },
  icon: p.string,
  label: p.string.isRequired,
  id: p.string,
  className: p.string,
  children: p.node.isRequired
};

var index = {
  version: pckg.version,
  Menu: Menu,
  MenuLink: MenuLink,
  MenuDrop: MenuDropRouter,
  Link: Link
};

exports.Link = Link;
exports.Menu = Menu;
exports.MenuDrop = MenuDropRouter;
exports.MenuLink = MenuLink;
exports.default = index;
//# sourceMappingURL=index.js.map
